<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-autocomplete
        v-model="data['slide']"
        :filter="v => v"
        :items="slides"
        :loading="isLoading"
        :search-input.sync="search"
        autofocus
        solo
        flat
        cache-items
        dense
        item-text="name"
        item-value="_id"
        label="Search for Slide"
        return-object
        single-line
      >
        <template v-slot:item="data">
          <template v-if="typeof data.item !== 'object'">
            <v-list-item-content v-text="data.item" />
          </template>
          <template v-else>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name" />
              <v-list-item-subtitle v-html="data.item.externalId" />
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
    </v-layout>
    <v-img v-if="data['slide']" :src="data['slide'].asset.png" contain />
  </v-container>
</template>

<script>
// import {SlideService} from '@/services/modules/slide';
import { debounce } from 'lodash';
// const service = new SlideService();
export default {
  name: 'AssignSlideForm',
  props: ['data'],
  data() {
    return {
      values: {
        slide: null
      },
      slides: [],
      search: null,
      isLoading: false
    };
  },
  watch: {
    search(val) {
      this.isLoading = true;
      this.searchQuery(val);
    }
  },
  methods: {
    searchQuery: debounce(function(val) {
      const { SlideService } = require('@/services/modules/slide');
      new SlideService()
        .query({
          product: this.$store.state.product.selected.product._id,
          country: this.$store.state.product.selected.country,
          wildcard: val,
          active: true
        })
        .then(items => {
          this.slides = items.data;
          this.isLoading = false;
        });
    }, 500),
    sendData() {
      return this.$emit('data-dialog', this.values);
    },
    canSubmit() {
      this.$emit('canSubmit', true);
    }
  }
};
</script>

<style scoped></style>
